import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetUnitTasks_taskConnections_tasks as GetUnitTasksDataGenerated,
  GetUnitTasks as GetUnitTasksGenerated,
  GetUnitTasksVariables as GetUnitTasksVariablesGenerated,
} from "core/queries/__generated__/GetUnitTasks";

export interface GetUnitTasksTaskData extends GetUnitTasksDataGenerated {}
export interface GetUnitTasksResponse extends GetUnitTasksGenerated {}
export interface GetUnitTasksVariables extends GetUnitTasksVariablesGenerated {}

export const getUnitTasks = gql`
  query GetUnitTasks(
    $filter: TaskFilterInput
    $sort: [TaskSortInput!]
    $cursor: String = "0"
  ) {
    taskConnections(
      filter: $filter
      sort: $sort
      pagination: { cursor: $cursor, limit: 25 }
    ) {
      cursor
      hasMore
      tasks {
        id
        __typename
        name
        type
        assignee {
          id
          firstName
          lastName
          avatar: profilePicture {
            id
            url
          }
        }
        assignees {
          id
          firstName
          lastName
          avatar: profilePicture {
            id
            url
          }
        }
        city {
          id
        }
        dueAt
        subjectType
        tomTaskRecurrenceSetting {
          id
          daysOfWeek
          intervalAmt
          intervalUnit
          threadId
        }
        unit {
          id
          shortInternalRef
          bookingInfo {
            upcomingBooking {
              id
              checkInTime
            }
          }
          checkInCheckOutInfo {
            isVacantAllDayToday
            checkInToday {
              id
              checkInTime
              checkOutTime
              account {
                id
              }
            }
            checkOutToday {
              id
              checkOutTime
              account {
                id
              }
            }
            occupiedByToday {
              id
              checkOutTime
              account {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export interface UseGetUnitTasksQueryOptions {
  notifyOnNetworkStatusChange?: boolean;
  variables: GetUnitTasksVariables;
  skip?: boolean;
}

export const useGetUnitTasksQuery = ({
  notifyOnNetworkStatusChange = false,
  variables,
  skip = false,
}: UseGetUnitTasksQueryOptions) =>
  useQuery<GetUnitTasksResponse, GetUnitTasksVariables>(getUnitTasks, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange,
    skip,
    variables,
  });
